import utils from '../utils';

const NS = 'ShopListingProductBlock';
const CLS = 'shopListingProductBlock';

export class ShopListingProductBlock {
	constructor(element) {

	}

}
